// extracted by mini-css-extract-plugin
export const categoryList = "CategoryList-module--categoryList--1PO8a bootstrap--d-block--22E6x bootstrap--text-muted--390dy";